

export const SharePage = () => {
    
    return <div>SharePage</div>;
}